import React, { useEffect, useState } from 'react';
import './foliosfa.css';
import folios from '../../json/folios.json';

const FoliosFA = () => {

  const [folio, setFolio] = useState('');
  const [resultado, setResultado] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const verificarFolio = () => {
    const folioLimpio = folio.trim().toUpperCase();

    if (folios.seleccionados.includes(folioLimpio)) {
      setResultado('✅ Felicidades, has sido seleccionado. En breve nos comunicaremos contigo.');
    } else {
      setResultado('❌ Agradecemos tu participación. En esta ocasión no has sido seleccionado.');
    }
  };

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DGSP2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3
            className='title'
            style={{
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Consulta si fuiste seleccionado
          </h3>

          {/* 👇 TEXTO NUEVO */}
          <p
            style={{
              color: 'white',
              textAlign: 'center',
              fontSize: '18px',
              marginTop: '-10px',
              textShadow: '2px 2px 6px rgba(0,0,0,0.7)'
            }}
          >
            13ª. EDICIÓN DEL CONCURSO ESTATAL DE ARTESANÍAS “HECHO EN HIDALGO 2026" <br /> APOYOS ECONÓMICOS PARA RECONOCER LA TRAYECTORIA DE PERSONAS ARTESANAS 2026
          </p>

          {/* 🔍 FORMULARIO */}
          <div style={{ textAlign: 'center', margin: '20px' }}>
            <input
              type="text"
              placeholder="Ingresa tu CURP"
              value={folio}
              onChange={(e) => setFolio(e.target.value)}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: 'none',
                marginRight: '10px'
              }}
            />

            <button
              onClick={verificarFolio}
              style={{
                padding: '10px 20px',
                backgroundColor: '#8B0000',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Consultar
            </button>

            {resultado && (
              <p style={{ marginTop: '15px', fontWeight: 'bold', color: 'white' }}>
                {resultado}
              </p>
            )}
          </div>

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default FoliosFA;